<template>
  <v-dialog
    persistent
    v-model="showDialog"
    :max-width="dialogWidth"
  >
    <v-card flat class="sign-up">
      <v-row no-gutters>
        <v-col cols="12" sm="6" class="hidden-xs-only">
          <v-img
            :src="image"
            max-height="500px"
            position="center bottom"
          >
          </v-img>
        </v-col>
        <v-col cols="12" sm="6">
          <v-row align="center" no-gutters>
            <v-col cols="12" class="px-12 text-center">
              <h2 class="brand pt-10 pb-5 text-center">
                CHEF NATURELLE</h2>
              <h5>becomes</h5>
              <h2 class="pt-5 text-center">Rooted in Rituals</h2>
              <p class="find-us text-center">
                The story of Rooted in Rituals, as well as my offerings can be found in my new website.
              </p>
              <p class="find-us-link text-center">
                <a href="https://rootedinrituals.co.uk">
                  https://rootedinrituals.co.uk
                </a>
              </p>
              <p class="text-center">
                See you there!
              </p>
              <p class="text-center">Stephanie</p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import {
  VBtn,
  VCard,
  VCol,
  VDialog,
  VForm,
  VIcon,
  VImg,
  VRow,
  VSpacer,
  VTextField,
} from 'vuetify/lib'

import MailerService from '@/services/MailerService'
import {Validators} from '@/utils/validators'

export default {
  components: {
    VBtn,
    VCard,
    VCol,
    VDialog,
    VForm,
    VIcon,
    VImg,
    VRow,
    VSpacer,
    VTextField,
  },
  computed: {
    dialogWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '500'
        case 'sm': return '950'
        case 'md': return '950'
        case 'lg': return '950'
        case 'xl': return '950'
      }
      return '800'
    },
    showDialog() {
      return this.show
    }
  },
  data: () => ({
    image: require('@/assets/images/sign-up-image.jpg?vuetify-preload'),
    form: {
      form: {
        email: '',
        name: '',
      }
    },
    rules: {
      email: [
        value => Validators.required(value) || 'Email is required.',
        value => Validators.email(value),
      ],
      name: [value => Validators.required(value) || 'Name is required.'],
    },
    submitting: false,
    success: false,
    valid: false,
  }),
  methods: {
    onClose() {
      this.$emit('update:show', false)
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.submitting = true

        MailerService
          .subscribe(this.form.email, this.form.name, ['newsletter'])
          .then(() => {
            this.$refs.form.reset()
            this.submitting = false
            this.success = true
          });
      }
    }
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-up {
  h2 {
    color: rgba(0, 0, 0, 0.87);
    font-family: 'Nanum Myeongjo', serif !important;
    font-size: 30px;
  }

  h5 {
    font-size: 16px !important;
    font-weight: normal !important;
  }

  p {
    font-size: 18px;
  }

  .find-us {
    // font-size: 18px;
    margin: 50px 0px 0px 0px;
  }

  .find-us-link {
    // font-size: 18px;
    margin: 20px 0px 20px 0px;
  }

  .credit {
    color: rgba($color: white, $alpha: .7);
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 10px 20px;
    margin: 0;

    a {
      color: rgba($color: white, $alpha: .7);
    }
  }
}
</style>
